import { useCallback } from "react";


export const useSchemaGeneration = () => {

  // Функция для установки свойства в schema по пути (создает вложенные объекты при необходимости)
  const setSchemaProperty = useCallback((schema, path, value) => {

    let current = schema;
    for (let i = 0; i < path.length; i++) {
      const part = path[i];
      if (i === path.length - 1) {
        current[part] = value;
      } else {
        if (!current[part] || typeof current[part] !== 'object') {
          if (part === 'properties') {
            current[part] = {};
          } else {
            current[part] = { type: 'object', properties: {} };
          }
        }
        current = current[part];
      }
    }
  }, [])


  const setInitialDataValue = useCallback((data, fieldName, value) => {
  
    let current = data;
    current[fieldName] = value;
  }, [])


  // Рекурсивная функция для сбора свойств schema и значений initialData из элементов 'Control'
  const collectSchemaPropsAndData = useCallback((structure, schema, data) => {
    if (!structure) return;

    // Если это элемент 'Control' с schemaProps, вставляем их в schema по пути из scope
    if (structure.type === 'Control' && structure.scope && structure.schemaProps) {
      const path = structure.scope.slice(2).split('/').filter(Boolean);
      setSchemaProperty(schema, path, structure.schemaProps);
    }

    // Если это элемент 'Control' с initialData, вставляем их в data по пути из scope
    if (structure.type === 'Control' && structure.scope && structure.initialData) {
      const fieldName = structure.scope.slice(2).split('/').pop();
      setInitialDataValue(data, fieldName, structure.initialData);
    }

    // Если есть вложенные элементы, рекурсивно обрабатываем их
    if (Array.isArray(structure.elements)) {
      for (let element of structure.elements) {
        collectSchemaPropsAndData(element, schema, data);
      }
    }
  }, [setSchemaProperty, setInitialDataValue])

  

  // Рекурсивная функция для удаления лишних свойств (id и schemaProps)
  const removeExtras = useCallback((structure) => {
    if (!structure) return;

    delete structure.id;
    delete structure.schemaProps;
    delete structure.initialData;

    // Если есть вложенные элементы, рекурсивно обрабатываем их
    if (Array.isArray(structure.elements)) {
      for (let element of structure.elements) {
        removeExtras(element);
      }
    }
  }, [])
  

  const generateNewSchemas = useCallback((formStructure, easStaticRows) => {
    // Создаем пустой schema
    const newSchema = { type: 'object', properties: {} };
    const newData = { type: 'object' };

    // Собираем свойства из formStructure
    collectSchemaPropsAndData(formStructure, newSchema, newData);

    // Добавляем к schema объекты, которые отсутствуют в форме, но нужны для выгрузки в ЕАС
    newSchema.eas_static_rows = easStaticRows

    // Создаем глубокую копию formStructure для uiSchema
    const newUiSchema = JSON.parse(JSON.stringify(formStructure));

    // Удаляем лишние свойства из uiSchema
    removeExtras(newUiSchema);

    return ({newSchema, newData, newUiSchema})

  }, [collectSchemaPropsAndData, removeExtras])


  return {
    generateNewSchemas
  }

}

